exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  font-size: 16px;\n  position: relative;\n  min-height: 100%; }\n\nhtml, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  background-color: #fff !important; }\n", ""]);

// exports
